/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsReadAllFromSectionDesktopModel,
  IChatsBulkOperationsReadAllFromSectionDesktopRequest,
  IMappers,
  IChatsBulkOperationsReadAllFromSectionDesktopResponse,
  IChatsBulkOperationsReadAllFromSectionDesktopResponseError,
  TChatsBulkOperationsReadAllFromSectionDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsReadAllFromSectionDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/read-all-from-section-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsReadAllFromSectionDesktopModel;

function createChatsBulkOperationsReadAllFromSectionDesktopModel(
  parameters: IChatsBulkOperationsReadAllFromSectionDesktopRequest,
): TChatsBulkOperationsReadAllFromSectionDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsReadAllFromSectionDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsReadAllFromSectionDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsReadAllFromSectionDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsReadAllFromSectionDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsReadAllFromSectionDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createChatsBulkOperationsReadAllFromSectionDesktopModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsReadAllFromSectionDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsReadAllFromSectionDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsReadAllFromSectionDesktopResponse;
}

export {
  defaultConfig,
  createChatsBulkOperationsReadAllFromSectionDesktopModel,
  fetchChatsBulkOperationsReadAllFromSectionDesktop,
};
